export default "__VITE_ASSET__OM6aRBTZ__"